import React, { useEffect, useState } from "react";
import axios from "axios";
import { Area, AreaChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useWorkspace } from "@/context/WorkspaceContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-lg border border-white/10 bg-[#1A2238]/95 px-2.5 py-1.5 text-[11px] backdrop-blur-md">
      <div className="text-slate-400">{label}</div>
      <div className="font-mono text-slate-200">AGRI: <span style={{ color: "#5B8DEF" }}>{payload[0].value}</span></div>
    </div>
  );
};

export default function AgriHistory() {
  const { workspaceId } = useWorkspace();
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/agri/history`, { params: { workspace: workspaceId } }).then((r) => {
      if (!cancelled) setWeeks(r.data.weeks || []);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [workspaceId]);

  if (!weeks.length) return null;
  const first = weeks[0].score;
  const last = weeks[weeks.length - 1].score;
  const delta = last - first;

  return (
    <div className="card-eco p-6" data-testid="agri-history-widget" role="img" aria-label="AGRI score history">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">AGRI™ history</div>
          <div className="mt-1 font-display text-lg text-slate-100">12-week trend</div>
        </div>
        <div className="flex items-baseline gap-2">
          <span className="font-mono text-2xl font-light text-white">{last}</span>
          <span className="font-mono text-[11px]" style={{ color: delta >= 0 ? "#22C55E" : "#EF4444" }}>
            {delta >= 0 ? "+" : ""}{delta}
          </span>
        </div>
      </div>
      <div className="mt-3 h-[120px]">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={weeks} margin={{ left: 0, right: 0, top: 4, bottom: 0 }}>
            <defs>
              <linearGradient id="agriHistFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#5B8DEF" stopOpacity={0.45} />
                <stop offset="100%" stopColor="#5B8DEF" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis dataKey="week" stroke="#475569" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
            <YAxis stroke="#475569" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} width={28} domain={[40, 100]} />
            <Tooltip content={<CTooltip />} cursor={{ stroke: "rgba(91,141,239,0.4)", strokeWidth: 1 }} />
            <Area type="monotone" dataKey="score" stroke="#5B8DEF" strokeWidth={1.8} fill="url(#agriHistFill)" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
